import React, { Component } from 'react';
import './styles.css';
import Item from './Item';
import ItemLabel from './ItemLabel';
class BottleSelectorLayout extends Component {
	render() {
		return <div className="bottle-selector-layout">{this.props.children}</div>;
	}
}

Object.assign(BottleSelectorLayout, {
	Item,
	ItemLabel
});

export default BottleSelectorLayout;
